// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-content-summary {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 15px);
}

.cart-content-summary .cart-coupon {
  background-color: var(--color-blue-cream);
  padding: 25px;
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  margin-bottom: 25px;
}

.cart-content-summary .cart-coupon label {
  display: block;
  font-family: "Lexend Deca", sans-serif;
  margin-bottom: 10px;
  width: 100%;
}

.cart-content-summary .cart-coupon .cart-coupon-data {
  display: flex;
  justify-content: space-between;
}

.cart-content-summary .cart-coupon .cart-coupon-data input {
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  font-size: 12px;
  padding: 10px;
  font-family: "Lexend Deca", sans-serif;
  outline: none;
  width: 100%;
  margin: 0px 12.5px 0px 0px;
}

.cart-content-summary .cart-coupon .cart-coupon-data input:focus {
  border: 1px solid var(--color-blue-dark);
}

.cart-content-summary .cart-coupon .cart-coupon-data button {
  border-radius: 8px;
  border: 1px solid var(--color-blue-dark);
  color: var(--color-blue-dark);
  font-weight: 400;
  background-color: var(--color-white-main);
  font-size: 12px;
  padding: 10px;
  font-family: "Lexend Deca", sans-serif;
}

.cart-content-summary .cart-coupon .cart-coupon-data button:hover {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
}

.cart-content-summary .validation-user {
  background-color: var(--color-blue-cream);
  padding: 25px;
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  margin-bottom: 25px;
}

.cart-content-summary .validation-user label {
  display: block;
  font-family: "Lexend Deca", sans-serif;
  margin-bottom: 10px;
  width: 100%;
}

.cart-content-summary .validation-user input {
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  font-size: 12px;
  padding: 10px;
  font-family: "Lexend Deca", sans-serif;
  outline: none;
  width: 100%;
  margin: 0px 12.5px 0px 0px;
}

.cart-content-summary .validation-user input:focus {
  border: 1px solid var(--color-blue-dark);
}

.cart-content-summary .cart-summation {
  background-color: var(--color-blue-cream);
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  margin-bottom: 25px;
}

.cart-content-summary .cart-summation .body-summation {
  width: 100%;
  height: auto;
  padding: 25px;
}

.cart-content-summary .cart-summation .body-summation .row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.cart-content-summary .cart-summation .body-summation .row .mycart-item-text {
  font-family: "Lexend Deca", sans-serif;
  font-weight: 300;
  font-size: 14px;
}

.cart-content-summary .cart-summation .body-summation .row .mycart-item-price {
  font-weight: bolder;
  font-size: 14px;
  font-family: "Inter", sans-serif;
}

.cart-content-summary .cart-summation .footer-summation {
  background-color: var(--color-blue-cream-special);
  padding: 15px 25px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  border-radius: 0px 0px 8px 8px;
  border-top: 1px solid var(--color-border-gray);
}

.cart-content-summary .cart-summation .footer-summation .grand-total {
  font-weight: bolder;
  font-family: "Inter", sans-serif;
}

.cart-content-summary .cart-summation .footer-summation .total-mycart {
  font-weight: bolder;
  color: var(--color-blue-dark);
  font-family: "Inter", sans-serif;
}

.cart-content-summary .cart-options {
  width: 100%;
  height: auto;
}

.cart-content-summary .cart-options button {
  width: 100%;
  margin-bottom: 12.5px;
  padding: 10px;
  font-family: "Poppins", sans-serif;
  border-radius: 8px;
  font-size: 14px;
}

.cart-content-summary .cart-options .button-pay {
  background-color: var(--color-blue-dark);
  outline: none;
  border: 1px solid var(--color-blue-dark);
  color: var(--color-white-main);
  font-weight: bolder;
}

.cart-content-summary .cart-options .button-pay:hover {
background-color: var(--color-blue-circle);
border: 1px solid var(--color-blue-circle);
cursor: pointer;
}

.cart-content-summary .cart-options .button-buy {
  background-color: transparent;
  outline: none;
  border: 1px solid var(--color-blue-dark);
  color: var(--color-blue-dark);
  font-weight: 300;
  display: block;
  padding: 8px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}

.cart-content-summary .cart-options .button-buy:hover {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
}`, "",{"version":3,"sources":["webpack://./src/components/order-summary/OrderSummary.css"],"names":[],"mappings":"AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;AACA,0CAA0C;AAC1C,0CAA0C;AAC1C,eAAe;AACf;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC","sourcesContent":["@import url(\"../../App.css\");\n\n.cart-content-summary {\n  flex: 0 0 calc(25% - 15px);\n}\n\n.cart-content-summary .cart-coupon {\n  background-color: var(--color-blue-cream);\n  padding: 25px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  margin-bottom: 25px;\n}\n\n.cart-content-summary .cart-coupon label {\n  display: block;\n  font-family: \"Lexend Deca\", sans-serif;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.cart-content-summary .cart-coupon .cart-coupon-data {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cart-content-summary .cart-coupon .cart-coupon-data input {\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  font-size: 12px;\n  padding: 10px;\n  font-family: \"Lexend Deca\", sans-serif;\n  outline: none;\n  width: 100%;\n  margin: 0px 12.5px 0px 0px;\n}\n\n.cart-content-summary .cart-coupon .cart-coupon-data input:focus {\n  border: 1px solid var(--color-blue-dark);\n}\n\n.cart-content-summary .cart-coupon .cart-coupon-data button {\n  border-radius: 8px;\n  border: 1px solid var(--color-blue-dark);\n  color: var(--color-blue-dark);\n  font-weight: 400;\n  background-color: var(--color-white-main);\n  font-size: 12px;\n  padding: 10px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.cart-content-summary .cart-coupon .cart-coupon-data button:hover {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n}\n\n.cart-content-summary .validation-user {\n  background-color: var(--color-blue-cream);\n  padding: 25px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  margin-bottom: 25px;\n}\n\n.cart-content-summary .validation-user label {\n  display: block;\n  font-family: \"Lexend Deca\", sans-serif;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.cart-content-summary .validation-user input {\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  font-size: 12px;\n  padding: 10px;\n  font-family: \"Lexend Deca\", sans-serif;\n  outline: none;\n  width: 100%;\n  margin: 0px 12.5px 0px 0px;\n}\n\n.cart-content-summary .validation-user input:focus {\n  border: 1px solid var(--color-blue-dark);\n}\n\n.cart-content-summary .cart-summation {\n  background-color: var(--color-blue-cream);\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  margin-bottom: 25px;\n}\n\n.cart-content-summary .cart-summation .body-summation {\n  width: 100%;\n  height: auto;\n  padding: 25px;\n}\n\n.cart-content-summary .cart-summation .body-summation .row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.cart-content-summary .cart-summation .body-summation .row .mycart-item-text {\n  font-family: \"Lexend Deca\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n}\n\n.cart-content-summary .cart-summation .body-summation .row .mycart-item-price {\n  font-weight: bolder;\n  font-size: 14px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.cart-content-summary .cart-summation .footer-summation {\n  background-color: var(--color-blue-cream-special);\n  padding: 15px 25px;\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  border-radius: 0px 0px 8px 8px;\n  border-top: 1px solid var(--color-border-gray);\n}\n\n.cart-content-summary .cart-summation .footer-summation .grand-total {\n  font-weight: bolder;\n  font-family: \"Inter\", sans-serif;\n}\n\n.cart-content-summary .cart-summation .footer-summation .total-mycart {\n  font-weight: bolder;\n  color: var(--color-blue-dark);\n  font-family: \"Inter\", sans-serif;\n}\n\n.cart-content-summary .cart-options {\n  width: 100%;\n  height: auto;\n}\n\n.cart-content-summary .cart-options button {\n  width: 100%;\n  margin-bottom: 12.5px;\n  padding: 10px;\n  font-family: \"Poppins\", sans-serif;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.cart-content-summary .cart-options .button-pay {\n  background-color: var(--color-blue-dark);\n  outline: none;\n  border: 1px solid var(--color-blue-dark);\n  color: var(--color-white-main);\n  font-weight: bolder;\n}\n\n.cart-content-summary .cart-options .button-pay:hover {\nbackground-color: var(--color-blue-circle);\nborder: 1px solid var(--color-blue-circle);\ncursor: pointer;\n}\n\n.cart-content-summary .cart-options .button-buy {\n  background-color: transparent;\n  outline: none;\n  border: 1px solid var(--color-blue-dark);\n  color: var(--color-blue-dark);\n  font-weight: 300;\n  display: block;\n  padding: 8px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.cart-content-summary .cart-options .button-buy:hover {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
